// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rc-pageMsg{display:flex;align-items:center;gap:0.625rem;background:var(--v0dcf4f40);border-radius:0.25rem;padding:1.25rem;color:var(--s-d-80);font-size:0.875rem}.rc-pageMsg svg{width:1.5rem;height:1.5rem;fill:currentColor;flex-shrink:0;align-self:flex-start}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
